// extracted by mini-css-extract-plugin
module.exports = {"root":"LoseOverlay_root__3kbA-","lose":"LoseOverlay_lose__27SxD"};